import React from 'react';
import { Props } from '.';
import {
    formatTime,
    getEventIcon,
    getEventSubtitle,
    getEventTitle,
} from '../../../../helpers/EventHelper';
import { isPendingEvent } from '../../../../helpers/pendingEventHelpers';
import {
    CoachRoleEnum,
    EventTypeEnum,
    MatchCoachVm,
    TurnoverTypeEnum,
} from '../../../../utils/api';

class MatchLogItem extends React.PureComponent<Props> {
    public render = (): React.ReactElement => {
        const {
            event,
            isHomeTeam,
            lineups,
            lineup,
            coaches,
            editEvent,
            onRefereeMistakeChange,
            match,
        } = this.props;

        // the first class has white background and the second one has blue background
        const className = isHomeTeam ? 'c-event--goal-white-event' : 'c-event--goal-blue-event';
        const pendingClass = isPendingEvent(event as any) ? ' c-event--pending' : '';
        const cardedCoach = coaches.find(
            (c: MatchCoachVm): boolean => event.card?.cardedCoachId === c.id
        );
        const isTeamOnlyCard =
            event.typeId === EventTypeEnum.Card &&
            !!event.card?.typeId &&
            !event.card?.cardedCoachId &&
            !event.card?.cardedPlayerId;
        const isGoalkeeperChange = event.typeId === 707;
        const isClockExpiredTurnover =
            event.typeId === EventTypeEnum.Turnover &&
            event.turnover?.typeId === TurnoverTypeEnum.Clock_Expired;
        const lineupNumber =
            lineup && !isClockExpiredTurnover && !isGoalkeeperChange
                ? lineup.capNumber || lineup.number
                : '';

        let gkChangeSubtitle = '';
        const isStartingGoalkeeperEvent =
            isGoalkeeperChange &&
            event.goalkeeperChange &&
            event.goalkeeperChange.previousGoalkeeperMatchPlayerId == null;
        if (isGoalkeeperChange && event.goalkeeperChange) {
            const newGk = lineups.find(
                (l) => l.id === event.goalkeeperChange?.newGoalkeeperMatchPlayerId
            );
            const prevGk = lineups.find(
                (l) => l.id === event.goalkeeperChange?.previousGoalkeeperMatchPlayerId
            );
            const newCap = newGk ? `#${newGk.capNumber || newGk.number}` : '?';
            if (isStartingGoalkeeperEvent) {
                gkChangeSubtitle = `Starts ${newCap}`;
            } else {
                const prevCap = prevGk ? `#${prevGk.capNumber || prevGk.number}` : '?';
                gkChangeSubtitle = `${prevCap} → ${newCap}`;
            }
        }

        return (
            <div
                className={`c-event ${className}${pendingClass}`}
                onClick={(): void => editEvent(event)}
                role="button"
            >
                <span className="c-event__player-nbr">
                    {isTeamOnlyCard ? 'Team' : lineupNumber}
                    {!isTeamOnlyCard && cardedCoach
                        ? CoachRoleEnum[cardedCoach.roleId].replace('_', ' ')
                        : ''}
                </span>
                <span className="c-event__time">{formatTime(event.minute, event.seconds)}</span>
                <span className="c-event__icon">
                    {isGoalkeeperChange ? (
                        <span className="fake-svg">GK</span>
                    ) : (
                        getEventIcon(event)
                    )}
                </span>
                <span className="c-event__event">
                    <span className="c-event__event-name">
                        {isGoalkeeperChange
                            ? isStartingGoalkeeperEvent
                                ? 'Starting GK'
                                : 'GK Change'
                            : getEventTitle(event)}
                    </span>
                    <span className="c-event__event-note">
                        {isGoalkeeperChange
                            ? gkChangeSubtitle
                            : getEventSubtitle(event, lineups, match)}
                    </span>
                </span>
                <span className="c-event__referee-mistake">
                    <span
                        className={`c-event__mistake-btn c-event__mistake-btn--minor${
                            event.refereeMistake === 1 ? ' c-event__mistake-btn--active' : ''
                        }`}
                        role="button"
                        onClick={(e): void => {
                            e.stopPropagation();
                            onRefereeMistakeChange(event.id, event.refereeMistake === 1 ? null : 1);
                        }}
                    />
                    <span
                        className={`c-event__mistake-btn c-event__mistake-btn--major${
                            event.refereeMistake === 2 ? ' c-event__mistake-btn--active' : ''
                        }`}
                        role="button"
                        onClick={(e): void => {
                            e.stopPropagation();
                            onRefereeMistakeChange(event.id, event.refereeMistake === 2 ? null : 2);
                        }}
                    />
                </span>
            </div>
        );
    };
}

export default MatchLogItem;
